module.exports = __webpack_public_path__ + "static/img/home_bottom_01.07ba4c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_bottom_01.jpg
// module id = xhFq
// module chunks = 1